import { createAction } from '@reduxjs/toolkit';

export const startPriceRecalculation = createAction('ordersummary/startPriceRecalculation');

export const resetPriceRecalculationResponse = createAction('ordersummary/resetPriceRecalculationResponse');

export const savePriceRecalculationResponse = createAction('ordersummary/savePriceRecalculationResponse');

export const priceRecalculationFailed = createAction('ordersummary/priceRecalculationFailed');
